module.exports = __webpack_public_path__ + "img/logo_icon@2x.a0c59cdc.png";